module.exports = __webpack_public_path__ + "static/img/2025-07-02-1.1b4ea18c.png";